export function EntityLogo({ src, name }: { src?: string; name: string }) {
  if (src) {
    return <img className="entity-logo" src={src} alt="" loading="lazy" />;
  }
  const initials = name.split(/\s+/).map((part) => part[0]).join("").slice(0, 2).toUpperCase();
  return <span className="entity-logo entity-logo-fallback" aria-hidden="true">{initials}</span>;
}
